import {
  type IdCardPrepareSignatureMutationVariables,
  type IdCardSignContractMutationVariables,
  useIdCardPrepareSignatureMutation,
  useIdCardSignContractMutation,
} from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useSignContractWithIdCard = () => {
  const [prepareForIdCardSigning, { data, loading, error }] =
    useIdCardPrepareSignatureMutation({
      context: { apiVersion: AppApiVersions.core },
    });

  const [
    signIdCardContract,
    { data: idCardSignatureData, error: idCardSignatureError },
  ] = useIdCardSignContractMutation();

  const prepareIdCardContractSignature = (
    variables: IdCardPrepareSignatureMutationVariables,
  ) => prepareForIdCardSigning({ variables });

  const signContractWithIdCard = (
    variables: IdCardSignContractMutationVariables,
  ) =>
    signIdCardContract({
      variables,
      context: {
        apiVersion: AppApiVersions.core,
      },
    });

  return {
    idCardContractSignaturePreparationLoading: loading,
    idCardContractSignatureToken: data?.challenge?.token,
    idCardContractSignaturePreparationError: error,
    signContractWithIdCardSuccess: idCardSignatureData?.success,
    signContractWithIdCardError: idCardSignatureError,
    prepareIdCardContractSignature,
    signContractWithIdCard,
  };
};
